export default function Logo({ size = 38, light = true, withWordmark = true, subtitle = false }) {
  return (
    <span className="flex items-center gap-3 select-none">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-label="Voogly Education logo">
        <rect width="64" height="64" rx="14" fill={light ? "#0B0F19" : "#0B0F19"} />
        <path d="M15 15 L32 49 L49 15" stroke="#F59E0B" strokeWidth="7" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <circle cx="50" cy="50" r="5.5" fill="#10B981" />
      </svg>
      {withWordmark && (
        <span className="leading-none">
          <span className={`font-display font-extrabold tracking-tight ${light ? "text-white" : "text-ink"} text-lg block`}>
            Voogly <span className="text-amber-500">Education</span>
          </span>
          {subtitle && (
            <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400 mt-1 block">
              Notes · Courses · Instant
            </span>
          )}
        </span>
      )}
    </span>
  );
}
